<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <b-card title="Görsel">
          <b-img
            v-if="itemData.image"
            :src="itemData.image"
            thumbnail
            center
          />
          <div class="text-center mt-1">
            <b-button
              variant="primary"
              @click="setModal('desktop')"
            >
              <FeatherIcon icon="UploadIcon" />
              Görsel Yükle
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="carousel"
      :params="cropperSettings.type"
      :item-id="itemData.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BImg, BRow,
} from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage,
    BRow,
    BCol,
    BButton,
    BImg,
    BCard,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'desktop') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'carousel-image.jpg',
          folder: 'carousel',
          ratio: 4 / 3,
          widthSize: 1200,
          type: 'desktop',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'desktop') {
        this.itemData.image = item.base_url + item.filename
        this.itemData.thumb = item.base_url + item.thumb
        this.itemData.image_webp = item.base_url + item.filename_webp
        this.itemData.thumb_webp = item.base_url + item.thumb_webp
        this.itemData.mediaData = item
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
